import { patchState, signalStore, withMethods, withState } from '@ngrx/signals';
import { PublicExpert } from '@concretecode/shared';
import { withDevtools } from '@angular-architects/ngrx-toolkit';

type ExpertState = {
  experts: PublicExpert[];
};

const initialState: ExpertState = {
  experts: [],
};

export const ExpertStore = signalStore(
  { providedIn: 'root' },
  withDevtools('expert-store'),
  withState(initialState),
  withMethods((store) => ({
    setExperts(experts: PublicExpert[]): void {
      patchState(store, { experts });
    },
    reset(): void {
      patchState(store, () => ({ ...initialState }));
    },
  })),
);
